module.exports = __webpack_public_path__ + "static/media/archies-projects.079221da.png";